export type ComparisonOperatorType = {
  label: string;
  value: ComparisonOperator;
};

export const equalityOperators = [
  {
    label: 'is equal to',
    value: 'eq',
  },
  {
    label: 'is not equal to',
    value: '!eq',
  },
];

export const inequalityOperators = [
  {
    label: 'is greater than',
    value: 'gt',
  },
  {
    label: 'is less than',
    value: 'lt',
  },
  {
    label: 'is between',
    value: 'bw',
  },
];

export const existenceOperators = [
  {
    label: 'exists',
    value: 'exists',
  },
  {
    label: 'does not exist',
    value: '!exists',
  },
];

export const stringOperators = [
  {
    label: 'contains',
    value: 'contains',
  },
  {
    label: 'does not contain',
    value: '!contains',
  },
];

export const dateExistenceOperators = [
  {
    label: 'is a timestamp',
    value: 'timestamp',
  },
  {
    label: 'is not a timestamp',
    value: '!timestamp',
  },
];

export const dateInequalityOperators = [
  {
    label: 'is a timestamp after',
    value: 'timestamp_gt',
  },
  {
    label: 'is a timestamp before',
    value: 'timestamp_lt',
  },

  // absolute timestamp operators: with same labels and formatting, not displayed in operator select input when editing attributes
  {
    label: 'is a timestamp after',
    value: 'timestamp_gta',
  },
  {
    label: 'is a timestamp before',
    value: 'timestamp_lta',
  },
];

export const extraDateInequalityOperators = [
  {
    label: 'is a timestamp between',
    value: 'timestamp_bw',
  },
];

export const emailOperators = [
  {
    label: 'is valid',
    value: 'email_valid',
  },
  {
    label: 'is not valid',
    value: '!email_valid',
  },
];

export enum ComparisonOperator {
  Value = 'value',
  Customer = 'customer_attribute',
  Event = 'event_attribute',
  ForeignEventAttribute = 'foreign_event_attribute',
}

export const comparisonOperators: ComparisonOperatorType[] = [
  {
    label: 'the value',
    value: ComparisonOperator.Value,
  },
  {
    label: "the current person's attribute",
    value: ComparisonOperator.Customer,
  },
  {
    label: 'the trigger event attribute',
    value: ComparisonOperator.Event,
  },
];

export const arrayOperators = [
  {
    label: 'is contained in',
    value: 'contained_in_array',
  },
  {
    label: 'is not contained in',
    value: '!contained_in_array',
  },
];

export const dateOperators = [...dateExistenceOperators, ...dateInequalityOperators, ...extraDateInequalityOperators];

export default [
  ...equalityOperators,
  ...inequalityOperators,
  ...existenceOperators,
  ...stringOperators,
  ...dateOperators,
  ...emailOperators,
  ...arrayOperators,
];
